import React from 'react'
import PropTypes from 'prop-types'
import { withRouter, Switch as RouterSwitch } from 'react-router-dom'
import PrivateRoute from '../../../hocs/PrivateRoute'
import RatesPage from './RatesPage'

// /custom-duties/banking-rates and /custom-duties/car-rates (spec: 0041_exchange_rates_dashboard).
const BankingRates = () => <RatesPage table="banking" />
const CarRates = () => <RatesPage table="car" />

const routes = component => {
  const Routes = props => (
    <RouterSwitch>
      <PrivateRoute exact path={props.match.path} component={component} />
    </RouterSwitch>
  )
  Routes.propTypes = { match: PropTypes.object }
  return withRouter(Routes)
}

export const BankingRatesRoutes = routes(BankingRates)
export const CarRatesRoutes = routes(CarRates)
